/// <reference path="../../../../Scripts/typings/breeze/breeze.d.ts" />
/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
define('areas/shopitemtemplate/services/mappings',["require", "exports", "areas/shopitemtemplate/models/dto", "areas/shopitemtemplate/models/bindable"], function (require, exports, dto, vm) {
    "use strict";
    var Mapper = (function () {
        function Mapper() {
        }
        Mapper.mapShopItemTemplateFromDTO = function (source) {
            var template = new vm.TemplateVM();
            template.templateId = source.templateId;
            template.category = source.category;
            template.settingsXml = source.settingsXml;
            template.itemType = source.itemType;
            template.target = source.target;
            template.name = source.name;
            template.memberType = source.memberType;
            template.description = source.description;
            template.rowKey = source.rowKey;
            return template;
        };
        Mapper.mapShopItemTemplate2ShopItemStubFromDTO = function (source) {
            var shopitemstub = new vm.ShopItemStubVM();
            shopitemstub.name = source.name;
            shopitemstub.templateId = source.templateId;
            return shopitemstub;
        };
        Mapper.mapShopItemStubVm2ShopItemStubDto = function (source) {
            var shopitemstub = new dto.ShopItemStub();
            shopitemstub.name = source.name;
            shopitemstub.templateId = source.templateId;
            shopitemstub.uniqueItemId = source.uniqueItemId;
            shopitemstub.memberTypes = source.memberTypes;
            shopitemstub.targetOrganizations = source.targetOrganizations;
            shopitemstub.description = source.description;
            shopitemstub.isExternalApplication = source.isExternalApplication;
            return shopitemstub;
        };
        return Mapper;
    }());
    return Mapper;
});

